import { useRef, useState, useEffect } from 'react'

const MOBILE_WORDS = [
  { id: 'w1', text: 'CAWT', isBrand: true },
  { id: 'w2', text: 'aspires', isLight: true },
  { id: 'w3', text: 'to be the', isLight: true },
  { id: 'w4', text: 'driving force', isLight: true },
  { id: 'w5', text: 'that empowers', isLight: true },
  { id: 'w6', text: 'communities', isLight: false },
  { id: 'w7', text: 'and volunteers alike', isLight: false },
  { id: 'w8', text: 'to embrace', isLight: true },
  { id: 'w9', text: 'the future of animal welfare.', isLight: false, isAccent: true },
]

const VisionManifesto = () => {
  const sectionRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.15 }
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <section
      ref={sectionRef}
      className="relative max-w-7xl 2xl:max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 2xl:px-12 py-10 sm:py-14 lg:py-20 flex flex-col justify-between overflow-hidden bg-transparent select-none"
    >

      {/* Main Container */}
      <div className="max-w-5xl 2xl:max-w-6xl mx-auto w-full flex-grow flex flex-col justify-between relative z-10 py-2 sm:py-4">

        {/* Top Label */}
        <div className="flex items-center gap-2.5 sm:gap-3 mb-4 sm:mb-6 justify-start pl-0 sm:pl-8 md:pl-20 2xl:pl-24">
          <span className="text-[10px] xs:text-xs sm:text-[11px] 2xl:text-xs font-extrabold tracking-widest text-slate-500 uppercase">
            ABOUT CHETAK ANIMAL WELFARE TRUST
          </span>
          <div className="h-[1.5px] w-6 sm:w-12 2xl:w-16 bg-slate-400/80 shrink-0" />
        </div>

        {/* ============================================================== */}
        {/* MOBILE VIEW: Full-Screen Move-in Staggered Reveal with Bigger Typography */}
        {/* ============================================================== */}
        <div className="block sm:hidden text-left my-auto py-4">
          <h2 className="text-[30px] xs:text-[34px] font-medium leading-[1.3] text-slate-900 tracking-tight flex flex-wrap items-baseline gap-x-2.5 gap-y-2">
            {MOBILE_WORDS.map((w, idx) => {
              const delay = idx * 120

              if (w.isBrand) {
                return (
                  <span
                    key={w.id}
                    style={{
                      transitionDelay: `${delay}ms`,
                    }}
                    className={`inline-block font-normal text-5xl xs:text-6xl tracking-tight transition-all duration-700 transform ${
                      isVisible
                        ? 'opacity-100 translate-y-0 scale-100'
                        : 'opacity-0 translate-y-6 scale-125'
                    }`}
                  >
                    <span
                      style={{
                        fontFamily: "'Jumpswinter', sans-serif",
                        color: 'var(--color-brand-orange-700)',
                      }}
                      className="inline-block"
                    >
                      {w.text}
                    </span>
                  </span>
                )
              }

              return (
                <span
                  key={w.id}
                  style={{
                    transitionDelay: `${delay}ms`,
                  }}
                  className={`inline-block transition-all duration-600 transform ${
                    isVisible
                      ? 'opacity-100 translate-y-0'
                      : 'opacity-0 translate-y-4'
                  } ${
                    w.isLight
                      ? 'text-slate-400 font-light'
                      : w.isAccent
                      ? 'text-slate-900 font-semibold'
                      : 'text-slate-700 font-medium'
                  }`}
                >
                  {w.text}
                </span>
              )
            })}
          </h2>
        </div>

        {/* ============================================================== */}
        {/* DESKTOP VIEW: Full-Screen Editorial Manifesto with Bigger Typography */}
        {/* ============================================================== */}
        <div className="hidden sm:block my-auto py-6">
          <h2 className="text-4xl md:text-5xl lg:text-[52px] 2xl:text-[64px] text-slate-900 font-medium leading-[1.4] 2xl:leading-[1.36] tracking-tight pl-8 md:pl-24 lg:pl-32 2xl:pl-40 pr-0 text-left">
            <span
              className="font-normal text-5xl md:text-6xl lg:text-[62px] 2xl:text-[76px]"
              style={{
                fontFamily: "'Jumpswinter', sans-serif",
                color: 'var(--color-brand-orange-700)',
              }}
            >
              CAWT
            </span>{' '}
            <span className="text-slate-400 font-light">aspires</span> to be the{' '}
            <span className="text-slate-400 font-light">driving force</span>{' '}
            that <span className="text-slate-400 font-light">empowers</span>{' '}
            communities and volunteers alike to embrace the{' '}
            <span className="text-slate-400 font-light">future of animal welfare</span>.
          </h2>
        </div>

        {/* Bottom Label */}
        <div className="flex items-center gap-2.5 sm:gap-3 mt-4 sm:mt-6 md:mt-8 justify-end pr-0 sm:pr-8 md:pr-20 2xl:pr-24">
          <div className="h-[1.5px] w-6 sm:w-12 2xl:w-16 bg-slate-400/80 shrink-0" />
          <span className="text-[9px] xs:text-[10px] sm:text-[11px] 2xl:text-xs font-bold tracking-widest text-slate-500 uppercase">
            JOIN THE COMPASSION JOURNEY WITH US
          </span>
        </div>

      </div>
    </section>
  )
}

export default VisionManifesto
